var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Vue, Watch } from 'vue-property-decorator';
import { Event as ScheduleModel } from '@/models/Event';
import PageHeader from '@/components/page-header/PageHeader';
import { Student } from '@/models/Student';
import LoadFailed from '@/views/Errors/LoadFailed';
import { DateTime } from 'luxon';
import { blackKidIcons } from '@/support/Icon';
import { Presence } from '@/models/Presence';
import ErrorHandler from '@/support/ErrorHandler';
import TreatmentDialog from '@/views/Curricula/TreatmentDialog';
import { RolesEnum } from '@/items/Roles';
let Schedule = class Schedule extends Vue {
    constructor() {
        super(...arguments);
        this.students = [];
        this.subjects = [];
        this.schedule = new ScheduleModel();
        this.isLoading = true;
        this.selectedPresence = null;
        this.selectedAll = false;
        this.selectedUsers = [];
        this.intermediateSelect = false;
        this.selectedTag = null;
        // protected tags: Tag[] | null = null;
        this.isEditingTreatment = false;
        this.selectedStudentId = '';
        // temp
        this.auxiliaryBranches = [
            {
                text: 'School A',
                value: '123',
            },
            {
                text: 'School B',
                value: '456',
            },
            {
                text: 'School C',
                value: '789',
            },
        ];
    }
    get presenceOptions() {
        return [
            {
                label: this.$t('subject.schedule.present').toString(),
                value: 'present',
                icon: 'check',
                backgroundColor: 'light-green lighten-4',
            },
            {
                label: this.$t('subject.schedule.absent').toString(),
                value: 'absent',
                icon: 'close',
                backgroundColor: 'red lighten-4',
            },
            {
                label: this.$t('subject.schedule.tardy').toString(),
                value: 'tardy',
                icon: 'access_time',
                backgroundColor: 'yellow lighten-4',
            },
            {
                label: this.$t('subject.schedule.sick').toString(),
                value: 'sick',
                icon: 'local_hospital',
                backgroundColor: 'blue-grey lighten-4',
            },
            {
                label: this.$t('subject.schedule.approvedAbsence').toString(),
                value: 'approved_absence',
                icon: 'how_to_reg',
                backgroundColor: 'teal lighten-4',
            },
        ];
    }
    get tags() {
        const tags = [];
        if (this.$store.state.tags) {
            this.$store.state.tags.forEach((tag) => {
                tags.push({ text: tag.name, value: tag.id });
            });
        }
        return tags;
    }
    get breadcrumbs() {
        return [{ name: this.$tc('schedule.title', 2), path: '/schedules' }, { name: this.schedule.title || '', path: this.$route.path }];
    }
    get selectedCount() {
        let count = 0;
        this.selectedUsers.forEach((item) => {
            if (item !== null) {
                count += 1;
            }
        });
        return count;
    }
    mounted() {
        this.initialize();
    }
    fetchPresence(schedule) {
        new Presence()
            .event(schedule)
            .all()
            .then((presence) => {
            this.students.forEach((student, index) => {
                const studentPresence = presence.find((element) => {
                    return element.user === student.id;
                });
                if (studentPresence && studentPresence.status) {
                    this.$set(student, 'presence', studentPresence.status);
                }
            });
            this.isLoading = false;
        });
    }
    updateSchedule() {
        this.schedule
            .update({ tags: [this.selectedTag], validate: false })
            .then((response) => {
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    date(key) {
        return DateTime.fromSQL(this.schedule[key]);
    }
    icon(key) {
        key = key || 'others';
        return blackKidIcons[key];
    }
    changedSelectedAll(status) {
        this.selectedUsers.forEach((item, index) => {
            this.$set(this.selectedUsers, index, status ? this.students[index].id : null);
        });
    }
    selectedPresenceChanged() {
        if (!this.selectedPresence) {
            return;
        }
        this.selectedUsers.forEach((item, userIndex) => {
            if (!item) {
                return;
            }
            this.students[userIndex].presence = this.selectedPresence;
        });
        const payload = [];
        this.students.forEach((student) => {
            if (student.presence !== null) {
                payload.push({ user: student.id, status: student.presence });
            }
        });
        new Presence()
            .event(this.schedule)
            .put(payload)
            .then(() => {
            this.selectedPresence = null;
            this.intermediateSelect = false;
            this.selectedAll = false;
            this.selectedUsers.forEach((item, userIndex) => {
                this.selectedUsers[userIndex] = null;
            });
        });
    }
    selectedUsersChanged(selection) {
        const count = this.selectedCount;
        if (count === 0) {
            this.selectedAll = false;
        }
        this.intermediateSelect = count !== selection.length && count > 0;
    }
    presenceChanged(student, status) {
        student.presence = status;
        new Presence()
            .event(this.schedule)
            .put([{ user: student.id, status: student.presence }])
            .then(() => { });
    }
    async initialize() {
        this.isLoading = true;
        await this.fetchSchedule();
        this.isLoading = false;
    }
    async fetchSchedule() {
        try {
            const response = await new ScheduleModel()
                .include([
                'room',
                'subject',
                'subjects',
                'users',
                'tags',
                'datetimeslots',
                'treatment_labels',
            ])
                .filter({
                role: RolesEnum.STUDENT,
                is_chosen: true,
            })
                .find(this.$route.params.id);
            this.setScheduleClassProperties(response);
        }
        catch (error) {
            //
        }
    }
    setScheduleClassProperties(schedule) {
        this.$set(this, 'students', new Student().dataToModel({}, 'Student', schedule.users));
        this.schedule = schedule;
        if (schedule.tags && schedule.tags.length) {
            this.selectedTag = schedule.tags[0].id;
        }
        this.students.forEach((student, index) => {
            this.$set(this.selectedUsers, index, null);
        });
        this.fetchPresence(schedule);
    }
    openTreatmentDialog(studentId) {
        this.selectedStudentId = studentId;
        this.isEditingTreatment = true;
    }
    onTreatmentSaved() {
        this.isEditingTreatment = false;
        this.selectedStudentId = '';
        this.fetchSchedule();
    }
    tableScroll(value) {
        //
    }
    selectedTagChange(tag) {
        if (tag) {
            this.updateSchedule();
        }
    }
};
__decorate([
    Watch('selectedAll'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], Schedule.prototype, "changedSelectedAll", null);
__decorate([
    Watch('selectedPresence'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Schedule.prototype, "selectedPresenceChanged", null);
__decorate([
    Watch('selectedUsers'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], Schedule.prototype, "selectedUsersChanged", null);
__decorate([
    Watch('selectedTag'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Schedule.prototype, "selectedTagChange", null);
Schedule = __decorate([
    Component({
        components: {
            LoadFailed,
            PageHeader,
            TreatmentDialog,
        },
    })
], Schedule);
export default Schedule;
